import { handleKeyDownInput } from '#pplx/frontend/composer-sdk/internal/keyboard.js';
import { useCallback, useEffect, useRef } from 'react';
export function useComposerRootKeyDownInput({ editor, enterKeyBehavior = 'submit', isComposing, onCompositionStart, onCompositionEnd, ignoreDefaultPreventedEvents = false, onKeyDown, }) {
    const isComposingRef = useRef(isComposing ?? false);
    const enterKeyBehaviorRef = useRef(enterKeyBehavior);
    const ignoreDefaultPreventedEventsRef = useRef(ignoreDefaultPreventedEvents);
    const onCompositionStartRef = useRef(onCompositionStart);
    const onCompositionEndRef = useRef(onCompositionEnd);
    const onKeyDownRef = useRef(onKeyDown);
    if (isComposing !== undefined) {
        isComposingRef.current = isComposing;
    }
    enterKeyBehaviorRef.current = enterKeyBehavior;
    ignoreDefaultPreventedEventsRef.current = ignoreDefaultPreventedEvents;
    onCompositionStartRef.current = onCompositionStart;
    onCompositionEndRef.current = onCompositionEnd;
    onKeyDownRef.current = onKeyDown;
    const handleStartComposition = useCallback((event) => {
        isComposingRef.current = true;
        onCompositionStartRef.current?.(event);
    }, []);
    const handleEndComposition = useCallback((event) => {
        isComposingRef.current = false;
        onCompositionEndRef.current?.(event);
    }, []);
    const handleKeyDown = useCallback((event) => {
        if (ignoreDefaultPreventedEventsRef.current && event.defaultPrevented) {
            return;
        }
        handleKeyDownInput(event, {
            enterKeyBehavior: enterKeyBehaviorRef.current,
            isComposing: isComposingRef.current,
            onKeyDown: onKeyDownRef.current,
        });
    }, []);
    useEffect(() => {
        return editor?.registerRootListener((rootEl, prevEl) => {
            if (rootEl) {
                rootEl.addEventListener('compositionstart', handleStartComposition);
                rootEl.addEventListener('compositionend', handleEndComposition);
                rootEl.addEventListener('keydown', handleKeyDown);
            }
            if (prevEl) {
                prevEl.removeEventListener('compositionstart', handleStartComposition);
                prevEl.removeEventListener('compositionend', handleEndComposition);
                prevEl.removeEventListener('keydown', handleKeyDown);
            }
        });
    }, [editor, handleStartComposition, handleEndComposition, handleKeyDown]);
}
//# sourceMappingURL=useComposerRootKeyDownInput.js.map